import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWallet = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M20 7H5a2 2 0 0 1 0-4h13v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 5v13a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 12h5v4h-5a2 2 0 0 1 0-4z" })
	]
});
export default SvgWallet;
